import moment from 'moment'

export function calculateTimeDifference (startTime, endTime, subtractMinutes) {
	const start = moment(startTime, 'YYYY-MM-DD HH:mm:ss');
	const end = moment(endTime, 'YYYY-MM-DD HH:mm:ss');
	// 减去指定分钟数
	end.subtract(subtractMinutes, 'minutes');
	const duration = moment.duration(end.diff(start));
	const hours = duration.hours();
	const minutes = duration.minutes();
	let result = '';
	if (hours > 0) {
			result += `${hours}时`;
	} else {
			result += `0时`
	}
	if (minutes > 0) {
			result += `${minutes}分`;
	}
	if (result === '') {
			result = '0时';
	}
	return result;
}
